import { get } from 'lodash';

import {
  GET_INVESTOR_DETAILS_FAILURE,
  GET_INVESTOR_DETAILS_LOADING,
  GET_INVESTOR_DETAILS_SUCCESS,
  TRACK_INVESTMENT_PROCESS_LOADING,
  TRACK_INVESTMENT_PROCESS_SUCCESS,
  TRACK_INVESTMENT_PROCESS_FAILURE,
  UPDATE_INVESTOR_INVESTMENT_DETAIL,
  UPDATE_INVESTOR_INVESTMENT_PROCESS,
  UPDATE_INVESTOR_INVESTMENT_DOCUMENTS,
  UPDATE_INVESTOR_KYC_DETAIL,
  GET_INVESTMENT_DOCUMENTS,
  GET_INVESTMENT_DOCUMENTS_LOADING,
  GET_INVESTMENT_DOCUMENTS_FAILURE,
  GET_INVESTMENT_DOCUMENTS_SUCCESS,
  EMPTY_INVESTOR_STATE,
  EMPTY_INVESTMENT_DATA,
} from './Actions';
import { InvestorAction, InvestorState } from './Types';

export const investorInitialState: InvestorState = {
  investor: {
    id: '',
    name: '',
    role: '',
    email: '',
    linkedinUrl: '',
    twitterUrl: '',
    otherUrl: '',
    crunchbaseUrl: '',
    reviewed: false,
    anglelistUrl: '',
    fundingEntityType: '',
    investorKyc: [],
    investmentDetail: [],
  },
  investmentDocuments: [],
  investmentProcess: null,
  investorDeals: [],
  isLoading: false,
  isDocumentLoading: false,
  successMessage: '',
  errorMessage: '',
  isProcessLoading: false,
  errorProcessMessage: '',
};

const InvestorReducer = (
  state = investorInitialState,
  action: InvestorAction,
) => {
  const { type, payload, changeLoader } = action;
  switch (type) {
    case GET_INVESTOR_DETAILS_LOADING:
      return {
        ...state,
        isLoading: changeLoader === false ? false : true,
        successMessage: '',
        errorMessage: '',
      };
    case GET_INVESTOR_DETAILS_SUCCESS: {
      const investedSpv = get(
        payload,
        'investmentDetail',
        [],
      ).map((investment: any) => get(investment, 'spv'));
      return {
        ...state,
        isLoading: false,
        successMessage: 'successfully fetched',
        investor: { ...payload },
        investorDeals: investedSpv,
      };
    }
    case GET_INVESTOR_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: payload?.message,
      };
    case TRACK_INVESTMENT_PROCESS_LOADING:
      return {
        ...state,
        isProcessLoading: true,
        errorProcessMessage: '',
      };
    case TRACK_INVESTMENT_PROCESS_SUCCESS:
      return {
        ...state,
        isProcessLoading: false,
        investmentProcess: { ...payload },
      };
    case TRACK_INVESTMENT_PROCESS_FAILURE:
      return {
        ...state,
        isProcessLoading: false,
        investmentProcess: null,
        errorProcessMessage: payload?.message,
      };
    case GET_INVESTMENT_DOCUMENTS:
      return {
        ...state,
      };
    case GET_INVESTMENT_DOCUMENTS_LOADING:
      return {
        ...state,
        isDocumentLoading: true,
        successMessage: '',
        errorMessage: '',
      };
    case GET_INVESTMENT_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isDocumentLoading: false,
        successMessage: 'successfully fetched',
        investmentDocuments: payload,
      };
    case GET_INVESTMENT_DOCUMENTS_FAILURE:
      return {
        ...state,
        isDocumentLoading: false,
        investmentDocuments: [],
        errorMessage: payload?.message,
      };
    case UPDATE_INVESTOR_KYC_DETAIL:
      return {
        ...state,
        investor: {
          ...state.investor,
          investorKyc: { ...payload },
        },
      };
    case UPDATE_INVESTOR_INVESTMENT_DETAIL:
      return {
        ...state,
        investor: {
          ...state.investor,
          investmentDetail: { ...payload },
        },
      };
    case UPDATE_INVESTOR_INVESTMENT_PROCESS:
      return {
        ...state,
        investmentProcess: { ...payload },
      };
    case UPDATE_INVESTOR_INVESTMENT_DOCUMENTS:
      return {
        ...state,
        investmentDocuments: payload,
      };
    case EMPTY_INVESTMENT_DATA:
      return {
        ...state,
        investmentDocuments: [],
        investmentProcess: null,
        isProcessLoading: false,
        errorProcessMessage: '',
      };
    case EMPTY_INVESTOR_STATE:
      return {
        ...investorInitialState,
      };
    default:
      return state;
  }
};

export default InvestorReducer;
